import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Instagram, Youtube, Facebook, Twitter, Share2 } from "lucide-react";
import Logo from "@/components/Logo";
import NewsletterSignup from "@/components/NewsletterSignup";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer data-testid="site-footer" className="bg-white border-t border-zinc-200 py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2">
            <div className="mb-4">
              <Logo size="lg" />
            </div>
            <p className="text-sm text-zinc-600 max-w-xs leading-relaxed mb-6">{t("footer.tagline")}</p>
            <NewsletterSignup />
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold mb-4">{t("footer.platform")}</h4>
            <ul className="space-y-2 text-sm text-zinc-600">
              <li><a href="#cursos" className="hover:text-zinc-900">{t("nav.courses")}</a></li>
              <li><a href="/blog" className="hover:text-zinc-900">Blog & Recursos</a></li>
              <li><a href="#porque" className="hover:text-zinc-900">{t("nav.why")}</a></li>
              <li><a href="#testimonios" className="hover:text-zinc-900">{t("nav.testimonials")}</a></li>
              <li><a href="#faq" className="hover:text-zinc-900">{t("nav.faq")}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold mb-4">{t("footer.connect")}</h4>
            <ul className="space-y-2 text-sm text-zinc-600">
              <li><a href="/temario" className="hover:text-zinc-900">{t("footer.syllabus")}</a></li>
              <li><a href="/compartir" className="hover:text-zinc-900">Compartir &amp; ganar</a></li>
              <li><a href="mailto:hola@kursosonline.com" className="hover:text-zinc-900">hola@kursosonline.com</a></li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <Link data-testid="footer-social-instagram" className="w-8 h-8 border border-zinc-300 flex items-center justify-center hover:bg-zinc-900 hover:text-white transition" to="/compartir" aria-label="Instagram"><Instagram className="w-4 h-4" /></Link>
              <Link data-testid="footer-social-youtube" className="w-8 h-8 border border-zinc-300 flex items-center justify-center hover:bg-zinc-900 hover:text-white transition" to="/compartir" aria-label="YouTube"><Youtube className="w-4 h-4" /></Link>
              <Link data-testid="footer-social-facebook" className="w-8 h-8 border border-zinc-300 flex items-center justify-center hover:bg-zinc-900 hover:text-white transition" to="/compartir" aria-label="Facebook"><Facebook className="w-4 h-4" /></Link>
              <Link data-testid="footer-social-x" className="w-8 h-8 border border-zinc-300 flex items-center justify-center hover:bg-zinc-900 hover:text-white transition" to="/compartir" aria-label="X"><Twitter className="w-4 h-4" /></Link>
              <Link data-testid="footer-social-share" className="w-8 h-8 border border-zinc-300 flex items-center justify-center hover:bg-zinc-900 hover:text-white transition" to="/compartir" aria-label="Compartir"><Share2 className="w-4 h-4" /></Link>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-zinc-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-zinc-500">
          <p>© {new Date().getFullYear()} Kursos Online. {t("footer.rights")}</p>
          <p className="font-mono">{t("footer.madeIn")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
